import React, { useEffect } from 'react';
import SetChoices from './ms.options';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';

import ListAnimation from '../../../utils/animations/list';
const mapStateToProps = (state) => {
	const {
		questionNo,
		rightSectionProps,
		leftSectionProps,
	} = state.rootReducer.testPageDetails;

	return {
		questionNo,
		rightSectionProps,
		leftSectionProps,
	};
};

const MultiSelect = ({
	rightSectionProps: { choices, imageChoices },
	leftSectionProps: { prompt, questionId },
	questionNo,
}) => {
	useEffect(() => {
		appendScript('testMS');
		return () => {
			removeScript('testMS');
		};
	}, [questionId]);

	let choicelist = '';

	if (typeof choices !== 'undefined') {
		var seqIncrement = 0;
		choicelist = Object.keys(choices).map(function (choice) {
			if (choices[choice] === '') {
				return false;
			}
			seqIncrement = seqIncrement + 1;
			return (
				<SetChoices
					key={`que_${questionNo}_${seqIncrement}`}
					seqIncrement={seqIncrement}
					identifier={'mcqChoices'}
					choice={choice}
				/>
			);
		});
		appendScript('testMS');
	}

	return (
		<span>
			<TopQuestion />
			<section className="quiz-area-options multiple-ops">
				<h6>{prompt}</h6>
				<ListAnimation>
					{' '}
					<ul>{choicelist}</ul>
				</ListAnimation>
			</section>
		</span>
	);
};

export default connect(mapStateToProps)(MultiSelect);
